export default __webpack_public_path__ + "static/media/issac3.16615660.PNG";